import { schoolYearsData } from './schoolYearsData.js';
import { appointedYears } from './appointedYearsData.js';
import { equateYears } from './equateYearsData.js';

export const paraprofessionalsData = [
    {
        id: 'hello-there',
        jobTitle: 'paraprofessionals',
        components: [
            {
                type: "Title",
                content: "Paraprofessional",
            },
            {
                type: "Sub Title",
                content: "There are <strong>two factors</strong> that influence your pay:"
            },
            {
                type: "Content Box",
                title: "Salary Upgrades",
                textAlign: "left",
                icon: "teach-exp",
                content: [
                    {
                        content: 'College Credits and Working Experience',
                    },
                ]
            },
            {
                type: "Content Box",
                title: "Length of Employment",
                textAlign: "left",
                icon: "employment-length",
                content: [
                    {
                        content: 'Longevity',
                    },
                ]
            },
            {
                type: "Content",
                content: "We're going to check each one for errors."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Get started", 
                        linkId: "do-you-work-in-an-adult-education-program",
                    }
                ]
            }
        ]
    },
    {
        id: 'do-you-work-in-an-adult-education-program',
        jobTitle: 'paraprofessionals',
        background: [
            {
                color: "#F4F9E8",
            }
        ],
        components: [
            {
                type: "Title",
                content: "Before we begin...",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Do you work in an adult education program?",
            },
            {
                type: 'Question',
                id: "adult-education-program",
                content: [
                    {
                        question: "Yes",
                        answerId: "college-credits",
                        value: "yes"
                    },
                    {   
                        question: "No",
                        answerId: "college-credits",
                        value: "no"
                    }
                ]
            }
        ]
    },
    {
        id: 'college-credits',
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/teaching-exp-green.png"),
                width: "64px"
            },
            {
                type: "Title",
                content: "Salary Upgrades"
            },
            {
                type: "Content",
                content: "Paraprofessionals can earn higher pay by applying for Salary Upgrades. Each upgrade has certain education and experience requirments."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "See if you qualify",
                        linkId: "do-you-have-your-bachelors-degree",
                    }
                ]
            }
        ]
    },
    {
        id: 'do-you-have-your-bachelors-degree',
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Do you have your bachelor’s degree?"
            },
            {
                type: 'Question',
                id: "step-1-status",
                content: [
                    {
                        question: "Yes",
                        value: "pass",
                        answerId: "approved-90"
                    },
                    {   
                        question: "No",
                        answerId: "how-many-college-credits-have-you-earned",
                    },
                ]
            }
        ]
    },
    {
        id: 'how-many-college-credits-have-you-earned',
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "How many college credits have you earned?"
            },
            {
                type: 'Question',
                id: "step-1-status",
                content: [
                    {
                        question: "0-5 credits",
                        value: "pass",
                        answerId: "credits-0-5",
                    },
                    {
                        question: "6-14 credits",
                        value: "pass",
                        answerId: "credits-6-14",
                    },
                    {
                        question: "15-29 credits",
                        value: "pass",
                        answerId: "credits-15-29",
                    },
                    {
                        question: "30-44 credits",
                        value: "pass",
                        answerId: "credits-30-44",
                    },
                    {
                        question: "45-59 credits",
                        value: "pass",
                        answerId: "credits-45-59",
                    },
                    {
                        question: "60-89 credits",
                        value: "pass",
                        answerId: "credits-60-89",
                    },
                    {   
                        question: "90 or more credits",
                        answerId: "are-those-credits-from-an-approved-institution",
                    },
                ]
            }
        ]
    },
    {
        id: 'are-those-credits-from-an-approved-institution',
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Are those credits from a regionally-accredited college or university?"
            },
            {
                type: 'Question',
                id: "step-1-status",
                content: [
                    {
                        question: "Yes",
                        value: "pass",
                        answerId: "approved-90",
                    },
                    {   
                        question: "No",
                        answerId: "are-they-matriculated",
                    },
                ]
            }
        ]
    },
    {
        id: 'are-they-matriculated',
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Were those credits earned while you were registered as a matriculated student?"
            },
            {
                type: 'Modal',
                label: 'What does this mean?',
                title: "What is a matriculated student?",
                content: [
                    {
                        type: "Content Box",
                        content: "A matriculated student is one formally enrolled in a degree-bearing program at a college or university. A non-matriculated student is one taking a few courses without pursuing a full degree.",
                        textAlign: "left",
                    },
                ]
            },
            {
                type: 'Question',
                id: "step-1-status",
                content: [
                    {
                        question: "Yes",
                        value: "pass",
                        answerId: "matriculated-90",
                    },
                    {   
                        question: "No",
                        value: "pass",
                        answerId: "credits-90",
                    },
                ]
            }
        ]
    },
    {
        id: "approved-90",
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "Okay!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Now let's check your working experience."
            },
            {
                type: "Pay Code Stub",
                paycode: "90+ Approved",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "matriculated-90",
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "Okay!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Now let's check your working experience."
            },
            {
                type: "Pay Code Stub",
                paycode: "90+ Matriculated",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "credits-0-5",
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "Okay!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Now let's check your working experience."
            },
            {
                type: "Pay Code Stub",
                paycode: "0-5",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "credits-6-14",
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "Okay!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Now let's check your working experience."
            },
            {
                type: "Pay Code Stub",
                paycode: "6-14",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "credits-15-29",
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "Okay!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Now let's check your working experience."
            },
            {
                type: "Pay Code Stub",
                paycode: "15-29",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "credits-30-44",
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "Okay!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Now let's check your working experience."
            },
            {
                type: "Pay Code Stub",
                paycode: "30-44",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "credits-45-59",
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "Okay!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Now let's check your working experience."
            },
            {
                type: "Pay Code Stub",
                paycode: "45-59",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "credits-60-89",
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "Okay!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Now let's check your working experience."
            },
            {
                type: "Pay Code Stub",
                paycode: "60-89",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "credits-90",
        jobTitle: 'paraprofessionals',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "Okay!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Now let's check your working experience."
            },
            {
                type: "Pay Code Stub",
                paycode: "90+",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "when-were-you-appointed-by-the-doe-in-your-current-title",
        jobTitle: 'paraprofessionals',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "When were you annualized as a Paraprofessional by the NYC DOE?"
            },
            ...schoolYearsData,
            {
                type: "Checkbox",
                id: "appointed-after-school-year",
                content:[
                    {
                        label: "I was annualized <em>after</em> the school year began",
                        value: "checked",
                    }
                ]
            },
            {   
                type: 'Button', 
                precedence: "checkbox", 
                content: [
                    {
                        label: "Continue",
                        linkId: "payroll-portal",
                        hidden: true,
                        variableId: "appointed-date"
                    },
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed",
                        hidden: true,
                        variableId: "appointed-after-school-year"
                    }
                ]
            },
        ]
    },
    {
        id: "when-were-you-appointed",
        jobTitle: 'paraprofessionals',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "When were you annualized?"
            },
            {
                type: "Dropdown",
                id: "appointed-month",
                content: [
                    {
                        label: "Month",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "January",
                        value: "01"
                    },
                    {
                        label: "February",
                        value: "02"
                    },
                    {
                        label: "March",
                        value: "03"
                    },
                    {
                        label: "April",
                        value: "04"
                    },
                    {
                        label: "May",
                        value: "05"
                    },
                    {
                        label: "June",
                        value: "06"
                    },
                    {
                        label: "July",
                        value: "07"
                    },
                    {
                        label: "August",
                        value: "08"
                    },
                    {
                        label: "September",
                        value: "09"
                    },
                    {
                        label: "October",
                        value: "10"
                    },
                    {
                        label: "November",
                        value: "11"
                    },
                    {
                        label: "December",
                        value: "12"
                    }
                ]
            },
            {
                type: "Dropdown",
                id: "appointed-day",
                content: [
                    {
                        label: "Day",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1",
                        value: "1"
                    },
                    {
                        label: "2",
                        value: "2"
                    },
                    {
                        label: "3",
                        value: "3"
                    },
                    {
                        label: "4",
                        value: "4"
                    },
                    {
                        label: "5",
                        value: "5"
                    },
                    {
                        label: "6",
                        value: "6"
                    },
                    {
                        label: "7",
                        value: "7"
                    },
                    {
                        label: "8",
                        value: "8"
                    },
                    {
                        label: "9",
                        value: "9"
                    },
                    {
                        label: "10",
                        value: "10"
                    },
                    {
                        label: "11",
                        value: "11"
                    },
                    {
                        label: "12",
                        value: "12"
                    },
                    {
                        label: "13",
                        value: "13"
                    },
                    {
                        label: "14",
                        value: "14"
                    },
                    {
                        label: "15",
                        value: "15"
                    },
                    {
                        label: "16",
                        value: "16"
                    },
                    {
                        label: "17",
                        value: "17"
                    },
                    {
                        label: "18",
                        value: "18"
                    },
                    {
                        label: "19",
                        value: "19"
                    },
                    {
                        label: "20",
                        value: "20"
                    },
                    {
                        label: "21",
                        value: "21"
                    },
                    {
                        label: "22",
                        value: "22"
                    },
                    {
                        label: "23",
                        value: "23"
                    },
                    {
                        label: "24",
                        value: "24"
                    },
                    {
                        label: "25",
                        value: "25"
                    },
                    {
                        label: "26",
                        value: "26"
                    },
                    {
                        label: "27",
                        value: "27"
                    },
                    {
                        label: "28",
                        value: "28"
                    },
                    {
                        label: "29",
                        value: "29"
                    },
                    {
                        label: "30",
                        value: "30"
                    },
                    {
                        label: "31",
                        value: "31"
                    },
                ]
            },
            ...appointedYears,
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "payroll-portal",
                        hidden: true,
                        variableId: [
                            "appointed-month",
                            "appointed-day",
                            "appointed-year"
                        ]
                    }
                ]
            },
        ]
    },
    {
        id: "payroll-portal",
        jobTitle: 'paraprofessionals',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Does this code appear in the NYC DOE portal?"
            },
            {
                type: 'Modal',
                label: 'Where do I find this?',
                title: "Where to find your salary code:",
                content: [
                    {
                        type: "Content",
                        content: "1. Log into the <a href='https://payrollportal.nycboe.net' class='text-link' target='_blank'>NYC DOE payroll portal</a>",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "2. Under Employee Self Service, select Payroll Register",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-1.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "3. Select the tab labeled Salary Info",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-2.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "4. Your salary step is represented by the third and fourth characters of your salary code",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-para.png"),
                        width: "100%"
                    }
                ]
            },
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {   
                type: 'Question', 
                id: "step-2-status",
                content: [
                    {
                        question: "Yes",
                        value: "pass",
                        answerId: "great-teaching-experience",
                    },
                    {   
                        question: "No",
                        answerId: "did-you-ever-apply-for-a-salary-upgrade",
                    }
                ]
            }
        ]
    },
    {
        id: "did-you-ever-apply-for-a-salary-upgrade",
        jobTitle: 'paraprofessionals',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Did you ever apply for a salary upgrade?"
            },
            {   
                type: 'Question', 
                id: "step-2-status",
                content: [
                    {
                        question: "Yes",
                        value: "fail",
                        answerId: "you-may-have-a-salary-step-error",
                    },
                    {   
                        question: "No",
                        value: "fail",
                        answerId: "you-should-submit-a-salary-upgrade-application-to-the-doe",
                    }
                ]
            }
        ]
    },
    {
        id: "you-may-have-a-salary-step-error",
        jobTitle: 'paraprofessionals',
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "You may have a salary error."
            },
            {
                type: "Content",
                content: "After your salary checkup is complete, report the error through <a href='https://uft.sposto.com/salary-differential-error' target='_blank' class='text-link'>this online form</a> or call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a>. We will include this information again on the final review."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment"
                    }
                ]
            }
        ]
    },
    {
        id: "you-should-submit-a-salary-upgrade-application-to-the-doe",
        jobTitle: 'paraprofessionals',
        stepNumber: 2,
        components: [
            {
                type: "Alert",
                level: "warning",
                content: "Action Needed"
            },
            {
                type: "Title",
                content: "You should submit a salary upgrade application to the NYC DOE."
            },
            {
                type: "Content",
                content: "We recommend doing this right now to ensure you are getting paid correctly."
            },
            {
                type: "External Text Link",
                label: "Resubmit Your Application",
                buttonStyle: true,
                link: "https://nycenet.edu/salapps"
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkStyle: true,
                        linkId: "length-of-employment"
                    }
                ]
            }
        ]
    },
    {
        id: "great-teaching-experience",
        jobTitle: 'paraprofessionals',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "Great!",
                underline: true
            },
            {
                type: "Sub Title",
                content: " It sounds like you are getting paid correctly for your college credits and work experience. Now let's check your longevity."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment"
                    }
                ]
            }
        ]
    },
    {
        id: "length-of-employment",
        jobTitle: 'paraprofessionals',
        stepNumber: 3,
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/length-of-employment-green.png"),
                alt: "Length of Emplpoyment Icon",
                width: "65px"
            },
            {
                type: "Title",
                content: "Length of Employment"
            },
            {
                type: "Content",
                content: "Paraprofessionals get additional salary increases on two key work anniversaries: 5 and 15 years. These increases, called longevities, add thousands to your salary. Let’s see when you can celebrate."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Remember your anniversaries",
                        linkId: "correct-apponted-date"
                    }
                ]
            }
        ]
    },
    {
        id: "correct-apponted-date",
        jobTitle: 'paraprofessionals',
        stepNumber: 3,
        components: [
            {
                type: "Appointed Date",
                content: "You told us you were annualized on",
            },
            {
                type: "Sub Title",
                content: "Is this correct?"
            },
            {   
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                    },
                    {   
                        question: "No",
                        answerId: "when-were-you-appointed-by-the-doe-in-your-current-title-incorrect",
                    }
                ]
            }
        ]
    },
    {
        id: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
        jobTitle: 'paraprofessionals',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Have you ever been off NYC DOE payroll for more than 30 days?"
            },
            {   
                type: 'Question',
                id: "step-3-status",
                content: [
                    {
                        question: "Yes",
                        value: "fail",
                        answerId: "off-doe-payroll-for-more-than-30-days"
                    },
                    {   
                        question: "No",
                        answerId: [
                            "no-longevity-increase",
                            "highest-longevity",
                            "longevity-increase"
                        ],
                        variableId: "appointed-date"
                    }
                ]
            }
        ]
    },
    {
        id: "off-doe-payroll-for-more-than-30-days",
        jobTitle: 'paraprofessionals',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Being off NYC DOE payroll for more than 30 days may impact your longevity schedule."
            },
            {
                type: "Content",
                content: "We recommend that you call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a> to confirm your information."
            },
            {   
                type: 'Button',
                content: [
                    {
                        label: "Continue to Final Review",
                        linkStyle: true,
                        linkId: "final-review"
                    }
                ]
            }
        ]
    },
    {
        id: "when-were-you-appointed-by-the-doe-in-your-current-title-incorrect",
        jobTitle: 'paraprofessionals',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "When were you annualized?"
            },
            ...schoolYearsData,
            {
                type: "Checkbox",
                id: "appointed-after-school-year",
                content:[
                    {
                        label: "I was appointed <em>after</em> the school year began",
                        value: "checked",
                    }
                ]
            },
            {   
                type: 'Button', 
                precedence: "checkbox", 
                content: [
                    {
                        label: "Continue",
                        linkId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                        hidden: true,
                        variableId: "appointed-date"
                    },
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-longevity",
                        hidden: true,
                        variableId: "appointed-after-school-year"
                    }
                ]
            },
        ]
    },
    {
        id: "when-were-you-appointed-longevity",
        jobTitle: 'paraprofessionals',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "When were you annualized?"
            },
            {
                type: "Dropdown",
                id: "appointed-month",
                content: [
                    {
                        label: "Month",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "January",
                        value: "01"
                    },
                    {
                        label: "February",
                        value: "02"
                    },
                    {
                        label: "March",
                        value: "03"
                    },
                    {
                        label: "April",
                        value: "04"
                    },
                    {
                        label: "May",
                        value: "05"
                    },
                    {
                        label: "June",
                        value: "06"
                    },
                    {
                        label: "July",
                        value: "07"
                    },
                    {
                        label: "August",
                        value: "08"
                    },
                    {
                        label: "September",
                        value: "09"
                    },
                    {
                        label: "October",
                        value: "10"
                    },
                    {
                        label: "November",
                        value: "11"
                    },
                    {
                        label: "December",
                        value: "12"
                    }
                ]
            },
            {
                type: "Dropdown",
                id: "appointed-day",
                content: [
                    {
                        label: "Day",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1",
                        value: "1"
                    },
                    {
                        label: "2",
                        value: "2"
                    },
                    {
                        label: "3",
                        value: "3"
                    },
                    {
                        label: "4",
                        value: "4"
                    },
                    {
                        label: "5",
                        value: "5"
                    },
                    {
                        label: "6",
                        value: "6"
                    },
                    {
                        label: "7",
                        value: "7"
                    },
                    {
                        label: "8",
                        value: "8"
                    },
                    {
                        label: "9",
                        value: "9"
                    },
                    {
                        label: "10",
                        value: "10"
                    },
                    {
                        label: "11",
                        value: "11"
                    },
                    {
                        label: "12",
                        value: "12"
                    },
                    {
                        label: "13",
                        value: "13"
                    },
                    {
                        label: "14",
                        value: "14"
                    },
                    {
                        label: "15",
                        value: "15"
                    },
                    {
                        label: "16",
                        value: "16"
                    },
                    {
                        label: "17",
                        value: "17"
                    },
                    {
                        label: "18",
                        value: "18"
                    },
                    {
                        label: "19",
                        value: "19"
                    },
                    {
                        label: "20",
                        value: "20"
                    },
                    {
                        label: "21",
                        value: "21"
                    },
                    {
                        label: "22",
                        value: "22"
                    },
                    {
                        label: "23",
                        value: "23"
                    },
                    {
                        label: "24",
                        value: "24"
                    },
                    {
                        label: "25",
                        value: "25"
                    },
                    {
                        label: "26",
                        value: "26"
                    },
                    {
                        label: "27",
                        value: "27"
                    },
                    {
                        label: "28",
                        value: "28"
                    },
                    {
                        label: "29",
                        value: "29"
                    },
                    {
                        label: "30",
                        value: "30"
                    },
                    {
                        label: "31",
                        value: "31"
                    },
                ]
            },
            ...appointedYears,
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                        hidden: true
                    }
                ]
            },
        ]
    },
    {
        id: "no-longevity-increase",
        jobTitle: 'paraprofessionals',
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "Keep going!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "See all of your longevity increases",
                        value: "pass",
                        linkId: "longevity-schedule"
                    }
                ]
            }
        ]
    },
    {
        id: "highest-longevity",
        jobTitle: 'paraprofessionals',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "You are amazing!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "This increase has become part of your base salary and is pensionable."
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "Go to final review",
                        linkId: "final-review",
                        value: "pass"
                    }
                ]
            }
        ]
    },
    {
        id: "longevity-increase",
        jobTitle: 'paraprofessionals',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "Congrats!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "This increase has become part of your annual salary and is pensionable."
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "See your next increases",
                        value: "pass",
                        linkId: "longevity-schedule"
                    }
                ]
            }
        ]
    },
    {
        id: "longevity-schedule",
        jobTitle: 'paraprofessionals',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Here are your forecasted longevity dates."
            },
            {
                type: 'Modal',
                label: 'When will I see my pay increase?',
                title: "When will my longevity increase show up in my paycheck?",
                content: [
                    {
                        type: "Content",
                        content: "Longevity increases should be reflected in 1&ndash;2 pay periods following your eligibility date and will include any retroactive pay if applicable.",
                        textAlign: "center",
                    }
                ]
            },
            {
                type: "Longevity Schedule"
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "final-review",
                    }
                ]
            }
        ]
    },
    {
        id: "final-review",
        jobTitle: 'paraprofessionals',
        background: [
            {
                color: "#17724D",
            }
        ],
        stepNumber: 4,
        components: [
            {
                type: "Title",
                content: "Final Review",
            },
            {
                type: "Sub Title",
                content: "We checked each aspect of your pay for errors."
            },
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {
                type: "Content Box",
                title: "Salary Upgrades",
                textAlign: "left",
                errorCheck: "step-2-status",
                content: [
                    {
                        content: 'College Credits and Working Experience',
                    },
                ],
                modal:[
                    {
                        label: 'Take action',
                        title: "Recommended Action",
                        content: [
                            {
                                type: "Alert",
                                level: "warning",
                                alert: "Salary Step Error"
                            },
                            {
                                type: "Content",
                                content: "Based on the information you provided, you may be eligible for a Salary Upgrade",
                                textAlign: "center",
                            },
                            {
                                type: "Pay Code",
                                codeType: "salary step"
                            },
                            {
                                type: "Content",
                                content: "You must apply for a Salary Upgrade; they are not applied automatically.",
                                textAlign: "center",
                            },
                            {
                                type: "External Link",
                                label: "Apply for a Salary Upgrade",
                                link: "https://nycenet.edu/salapps",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Call a UFT Salary Specialist",
                                link: "tel:212-331-6311",
                                isButtonStyle: true
                            }
                        ]
                    }
                ]
            },
            {
                type: "Content Box",
                title: "Length of Employment",
                textAlign: "left",
                errorCheck: "step-3-status",
                content: [
                    {
                        content: 'Longevity',
                    },
                ],
                modal:[
                    {
                        label: 'Take action',
                        title: "Recommended Action",
                        content: [
                            {
                                type: "Alert",
                                level: "warning",
                                alert: "Longevity Issue"
                            },
                            {
                                type: "Content",
                                content: "Because you were off NYC DOE payroll for 30 or more days, we recommend that you call a UFT Salary Specialist to ensure your longevity schedule is correct.",
                                textAlign: "center",
                            },
                            {
                                type: "External Link",
                                label: "Call a UFT Salary Specialist",
                                link: "tel:212-331-6311",
                                isButtonStyle: true
                            }
                        ]
                    }
                ]
            },
            {
                type: "Salary Schedule Codes",
                title: "Your place on the NYC DOE salary schedule:",
                content: [
                    {
                        type: "Content",
                        content: "Be sure you are reviewing the column that corresponds to the current contract date, and be sure to include the appropriate longevity pay listed toward the bottom of the salary schedule (less than 5 years, 5 years or 15 years)."
                    },
                    {
                        type: "External Link",
                        label: "Open Paraprofessional<br/>Salary Schedule",
                        link: "https://www.uft.org/your-rights/salary/doe-and-city-salary-schedules/para-salary-schedule"
                    }
                ]
            },
            {
                type: "Longevity Schedule",
                title: "Forecasted longevity dates:",
            },
        ]
    }
]